import babyboonet from "../../images/kidsproducts/baby_boonet.jpg";
import babyboots from "../../images/kidsproducts/baby_boots.jpg";
import babycap from "../../images/kidsproducts/baby_cap.jpg";
import babydress from "../../images/kidsproducts/baby_dress.jpg";
import babyshoes from "../../images/kidsproducts/baby_shoes.jpg";
import babysweatshirt from "../../images/kidsproducts/baby_sweatshirt.jpg";

const KidsProducts = [
  {
    image: babyboonet,
    name: "Baby Bonnet",
    price: "$12.00 USD",
  },
  {
    image: babyboots,
    name: "Winter Boots",
    price: "$14.00 USD",
  },
  {
    image: babycap,
    name: "Cap for kids",
    price: "$5.99 USD",
  },
  {
    image: babydress,
    name: "Baby dress",
    price: "$30.90 USD",
  },
  {
    image: babyshoes,
    name: "Shoes",
    price: "$25.00 USD",
  },
  {
    image: babysweatshirt,
    name: "Sweat shirt",
    price: "$13.00 USD",
  },
];

export default KidsProducts;
